/*
 * Product color reference:
 * https://docs.google.com/spreadsheets/d/143ehmL_jT0D6cjzJzHrF74hW0NlQPWh2XgX64wBLHcQ/edit#gid=0
 * Keep in sync with CSSVariables.prj > GetColorNames and portal quasar-variables.sass.
 */
export const defaultTheme = Object.freeze({
    /* Quasar core */
    anchor: '#2c92ff',
    primary: '#4F46E5',
    secondary: '#424242',
    accent: '#a7a2f2',
    negative: '#dc2626',
    positive: '#4ab574',
    info: '#2c92ff',
    warning: '#d97706',
    dark: '#28283c',

    /* Text */
    primaryText: '#1e293b',
    secondaryText: '#64748b',
    /* #a6a6b6 was the one value carried over from the old palette and Oliwia confirmed it is a
       mistake: it measures 2.40 on white where text needs 4.5, and it is the exact grey the
       accessibility work has just darkened in the Vue 2 apps. Her Figma has #64748b for
       secondary text and icons, which is 4.76, so tertiary text and the icon grey both take it
       and now hold the same value as secondaryText. CCDEV-16813. */
    tertiaryText: '#64748b',
    stateText: '#c8c8dc',
    primaryActive: '#5b5ceb',
    activeBackground: '#eef0ff',

    /* Controls */
    header: '#2e3358',
    gridHeader: '#e9eef7',
    navHeader: '#e9eef7',
    navHeaderText: '#394066',
    navigation: '#394066',
    gridOddRow: '#f6f8fc',
    destructive: '#dc2626',
    danger: '#dc2626',
    error: '#dc2626',
    success: '#16a34a',
    checkboxGrey: '#abb2c1',
    lightgrey: '#828296',
    darkContent: '#64748B',
    lightGreyBorder: '#e7eaf2',
    /* Mid grey for selection bullets / radio dots on light or dark menus.
       Distinct from lightGreyBorder (#e7eaf2), which is for actual borders. */
    selectionBullet: '#73738A',
    stateBackground: '#3c3c50',
    pageBackground: '#fbfcfe',
    lightBlueBackground: '#505064',
    darkGreyIcon: '#64748b',

    /* Base colors */
    blue: '#2c92ff',
    green: '#4ab574',
    yellow: '#ffde51',
    red: '#ef4a41',
    cyan: '#e3eefe',
    lightGrey: '#828296',
    extraLightGrey: '#fafafa',
    white: '#ffffff',
    black: '#000000',
    blueExtraLight: '#fafafa',
    lightGreyHover: '#5e5e6d',

    /* Dashboard */
    asa: '#2c92ff',
    att: '#702cff',
    awrapt: '#0155a3',

    /* Phone */
    sentmessage: '#d5e9ff',
    altsentmessage: '#dcf7c3',
    wrapup: '#0155a3',
    multiples: '#702cff',
    inbound: '#2c92ff',
    outbound: '#e07a1a',
    ready: '#4ab574',
    notready: '#dc2626',
    fullcapacity: '#ffde51',
    receivedmessage: '#f0f0f0',

    /* Not Ready States */
    notready1: '#ef4a41',
    notready2: '#d7433b',
    notready3: '#bf3b34',
    notready4: '#a7342e',
    notready5: '#8f2c27',
    notready6: '#782521',
    notready7: '#601e1a',
    notready8: '#481613',
    notready9: '#300f0d',

    /* Chart States */
    busy: '#828296',
    linked: '#2c92ff',
    transfer: '#0155a3',
    reading: '#702cff',
    unlinked: '#0155a3',
    composing: '#e07a1a',
    starting: '#828296',
    chatting: '#702cff',
    hold: '#0155a3',
    answered: '#2c92ff',
    pending: '#828296',

    /* User States */
    userState1: '#ffde51',
    userState2: '#eda926',
    userState3: '#e07a1a',
    userState4: '#d5562e',
    userState5: '#b5322c',
    userState6: '#7d1d4e',
    userState7: '#8d6fcc',
    userState8: '#702cff',
    userState9: '#3b02b6',
    userState10: '#78b3f0',
    userState11: '#4994ec',
    userState12: '#0155a3',
    userState13: '#74cdde',
    userState14: '#4da8be',
    userState15: '#39818d',
});

export default defaultTheme;
